/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import DisplayIcon from "../Icons/DisplayIcon.jsx";

function SettingsMenuItem({onClick, iconName, isSelected, Name, iconClass = ""}) {
    return (
        <div
            onClick={() => onClick?.()}
            className={`relative pl-2 py-2.5 pr-1 rounded flex items-center space-x-2 hover:bg-gray-100 focus-within:ring-2  focus-within:ring-inset focus-within:ring-indigo-500 cursor-pointer group ${isSelected && ("bg-blue-500 hover:!bg-blue-500 text-white")}`}>
            <div className="flex-shrink-0 mr-3 ml-0.5">
                <div
                    className={`size-6! bg-blue-400 text-white rounded-lg flex items-center justify-center ${iconClass}`}>
                    <DisplayIcon iconName={iconName} className={"size-4!"}/>

                </div>
            </div>
            <div className="flex-1 min-w-0 ">
                <div className="focus:outline-none">
                    <p className={`text-sm font-medium text-gray-900 select-none truncate ${isSelected && ("text-white")}`}>
                        {Name}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SettingsMenuItem;
